import gql from 'graphql-tag'

export default gql`
    mutation SendVZFMailAndSave($vzfID: String!, $input: VZFDataInput!, $pdfData: VZFPDFData!, $B2B: Boolean!) {
        sendVZFMailAndSave(vzfID: $vzfID, input: $input, pdfData: $pdfData, B2B: $B2B) {
            status
        }
    }
`
